import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import CompanyActiveList from "./components/Company-Active-List/CompanyActiveList";
import CompanyUnderReview from "./components/Company-Under-Review-List/CompanyUnderReview";

function Company_List() {
  const [type, setType] = useState("0");
  return (
    <>
      <div className="status-buttons mb-3">
        <span
          onClick={() => setType("0")}
          className={
            type === "0"
              ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0"
          }
        >
          Approved
        </span>
        <span
          onClick={() => setType("1")}
          className={
            type === "1"
              ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled  active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled "
          }
        >
          Under Review
        </span>

        <div className="clearfix"></div>
      </div>
      {/* table calling */}

      {type === "0" && <CompanyActiveList />}
      {type === "1" && <CompanyUnderReview />}
    </>
  );
}
export default withRouter(Company_List);
